import { CasualTournamentDetails } from '@fantaz/shared/data-access/models';
import { createAction, props } from '@ngrx/store';

export const loadCasualTournamentDetails = createAction(
  '[CasualTournamentDetails Page] loadCasualTournamentDetails',
  props<{ url: string; eventId?: string }>(),
);

export const loadCasualTournamentDetailsSuccess = createAction(
  '[CasualTournamentDetails/API] Load CasualTournamentDetails Success',
  props<{ casualTournamentDetails: CasualTournamentDetails }>(),
);

export const clearCasualTournamentDetails = createAction(
  '[CasualTournamentDetails/API] Clear CasualTournamentDetails',
);

export const loadCasualTournamentDetailsFailure = createAction(
  '[CasualTournamentDetails/API] Load CasualTournamentDetails Failure',
  props<{ error: any }>(),
);
export const loadCasualTournamentRating = createAction(
  '[CasualTournamentDetails Page] loadCasualTournamentRating',
  props<{ url: string; userId?: string }>(),
);
export const loadCasualTournamentRatingSuccess = createAction(
  '[CasualTournamentDetails Page] loadCasualTournamentRatingSuccess',
  props<{ casualTournamentRating: { stable: boolean; rating: number } }>(),
);
export const loadCasualTournamentDetailsSubscribed = createAction(
  '[CasualTournamentDetails Page] Casual Tournament Details Subscribed',
  props<{
    eventPrototypeUuid?: string;
    eventScheduleUuid: string;
    status: boolean;
  }>(),
);

export const timesUserTournamentPlayed = createAction(
  '[CasualTournamentDetails Page] Times User Tournament Played',
  props<{ eventPrototypeUuid: string; eventScheduleUuid: string }>(),
);
export const timesUserTournamentPlayedSuccess = createAction(
  '[CasualTournamentDetails Page] Times User Tournament Played Success',
  props<{ timesPlayed: number }>(),
);
export const timesUserTournamentPlayedFailure = createAction(
  '[CasualTournamentDetails Page] Times User Tournament Played Failure',
  props<{ error: unknown }>(),
);
